import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CheckboxComponent from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { useCsAttribute, useCsValue, useCsValueApi, useLocalOptionSelected, } from "@plansoft-configuration-renderer/framework";
import { useVisibleAttributeValues } from "../../AttributeValue";
import { useAttributeInlineLabel } from "../../Attributes/useAttributeInlineLabel";
import { useAttributeLayout } from "../../layouts/AttributeLayoutContext";
import { ValuesGrid } from "../Common/ValuesGrid";
export function Checkboxes(props) {
    const values = useVisibleAttributeValues();
    const { formLabel } = useAttributeInlineLabel();
    const { fullWidth, inlineValues } = useAttributeLayout();
    return (_jsxs(FormControl, { component: "fieldset", fullWidth: fullWidth, children: [formLabel, _jsx(FormGroup, { row: inlineValues, children: _jsx(ValuesGrid, { values: values, ValueDisplayComponent: CheckboxOption, children: props.children }) })] }));
}
function CheckboxOption(props) {
    const value = useCsValue();
    const attribute = useCsAttribute();
    const { toggleOption } = useCsValueApi();
    const isSelected = useLocalOptionSelected();
    const checkboxId = `checkbox-${attribute.id}-${value.value}`;
    const isDisabled = Boolean(!attribute.isAllowed ||
        attribute.isReadOnly ||
        !value.isAllowed ||
        !value.isActive);
    return (_jsx(FormControlLabel, { id: checkboxId, checked: isSelected, disabled: isDisabled, onChange: () => toggleOption(!isSelected), control: _jsx(CheckboxComponent, { disabled: isDisabled }), label: _jsx(_Fragment, { children: props.children }), disableTypography: true }));
}
//# sourceMappingURL=Checkboxes.js.map